'use es6';

import { PureComponent, Fragment } from 'react';
import { connect } from 'react-redux';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { COUNTRY_CODE_KEY } from 'FormsUI/constants/FormFieldMetadata';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { Toggle } from 'foundations-components/transitional/components/Toggle';
import FormFieldMinMaxConfigurationFieldInput from 'FormsUI/components/editor/form/configuration/FormFieldMinMaxConfigurationFieldInput';
import { FieldTypes } from 'ui-forms-components/constants/FieldTypeMapping';
import { getObjectTypeIdValue } from 'FormsCommonComponents/form-definition/utils/FormFieldUtils';
import { isContactProperty } from 'FormsCommonComponents/utils/PropertyObjectTypes';
import { getPropertyObjectTypeId } from 'FormsUI/utils/PropertiesUtils';
import { CommentableArea } from 'collaboration-sidebar';
import debounce from 'hs-lodash/debounce';
import { EDITED_DEFAULT_VALUE } from 'FormsUI/constants/TrackingInteractionKeys/Editor/FormTab';
import { trackEditorInteraction } from 'FormsUI/utils/TrackingUtils';
import getConfigurationType from 'forms-utils-lib/formField/utils/getConfigurationType';
import getMetaDataValue from 'forms-utils-lib/formField/utils/getMetaDataValue';
import updateFormFieldKey from 'forms-utils-lib/formField/utils/updateFormFieldKey';
import FormFieldKeys from 'forms-utils-lib/constants/formField/FormFieldKeys';
import updateMetaData from 'forms-utils-lib/formField/utils/updateMetaData';
import updateValidation from 'forms-utils-lib/formField/utils/updateValidation';
import { Spacer } from 'foundations-components/components/Spacer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const langKey = suffix => `editor.form.config.${suffix}`;
class PhoneNumber extends PureComponent {
  isCountryCodeSelectSupported() {
    const {
      field
    } = this.props;
    const objectTypeId = getObjectTypeIdValue(field.objectTypeId, field.propertyObjectType);
    return field.name === FieldTypes.PHONE && isContactProperty(objectTypeId);
  }
  isCountryCodeSelectEnabled() {
    const {
      field
    } = this.props;
    return this.isCountryCodeSelectSupported() && getMetaDataValue(field, COUNTRY_CODE_KEY) === 'true';
  }
  maybeRenderUseCountryCodeSelectToggle() {
    const {
      update,
      field
    } = this.props;
    if (!this.isCountryCodeSelectSupported()) {
      return null;
    }
    const isToggled = this.isCountryCodeSelectEnabled();
    return /*#__PURE__*/_jsx(CommentableArea, {
      moduleId: `${getPropertyObjectTypeId(field)}-country-code`,
      description: {
        translationKey: 'formsCountryCodeSelect'
      },
      children: /*#__PURE__*/_jsx("div", {
        "data-test-id": "config-input-field",
        children: /*#__PURE__*/_jsx(FormControl, {
          label: /*#__PURE__*/_jsx(FormattedMessage, {
            message: langKey('countryCodeSelect')
          }),
          children: /*#__PURE__*/_jsx(Toggle, {
            size: "small",
            checked: isToggled,
            onChange: () => update(updateMetaData(field, COUNTRY_CODE_KEY, `${!isToggled}`)),
            "data-editable-field": "use-country-code"
          })
        })
      })
    });
  }
  renderValidationField() {
    const {
      field,
      update
    } = this.props;
    const objectTypeId = getObjectTypeIdValue(field.objectTypeId, field.propertyObjectType);
    const fieldType = getConfigurationType(field);
    return /*#__PURE__*/_jsx(FormFieldMinMaxConfigurationFieldInput, {
      fieldType: getConfigurationType(field),
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: langKey('setValueLimits')
      }),
      tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
        message: langKey('numberToolTip')
      }),
      currentValue: field.validation.data,
      handleChange: newValue => update(updateValidation(field, {
        data: newValue
      })),
      field: field,
      fieldName: field.name,
      fieldPropertyObjectType: field.propertyObjectType,
      fieldObjectTypeId: objectTypeId,
      hideDisableCheckbox: fieldType !== FieldTypes.PHONE
    });
  }
  renderDefaultValueField() {
    const {
      field,
      update
    } = this.props;
    return /*#__PURE__*/_jsx(CommentableArea, {
      moduleId: `${getPropertyObjectTypeId(field)}-default-value`,
      description: {
        translationKey: 'formsDefaultValue'
      },
      children: /*#__PURE__*/_jsx("div", {
        "data-test-id": "config-input-field",
        children: /*#__PURE__*/_jsx(FormControl, {
          label: /*#__PURE__*/_jsx(FormattedMessage, {
            message: langKey('defaultValue')
          }),
          tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
            message: langKey('defaultValueToolTip')
          }),
          tooltipPlacement: "top right",
          children: /*#__PURE__*/_jsx(TextInput, {
            defaultValue: field.defaultValue,
            use: "on-dark",
            onChange: ({
              target: {
                value
              }
            }) => {
              debounce(() => trackEditorInteraction(EDITED_DEFAULT_VALUE), 1000)();
              update(updateFormFieldKey(field, FormFieldKeys.DEFAULT_VALUE, value));
            },
            "data-editable-field": "defaultValue"
          })
        })
      })
    });
  }
  renderPlaceholderField() {
    const {
      field,
      update
    } = this.props;
    const isPlaceholderDisabled = this.isCountryCodeSelectEnabled();
    const disabledMessage = /*#__PURE__*/_jsx(FormattedMessage, {
      message: langKey('countryCodeSelectWarning'),
      options: {
        fieldName: I18n.text(langKey('countryCodeSelect'))
      }
    });
    return this.props.renderPlaceholderField({
      value: field.placeholder,
      disabled: isPlaceholderDisabled,
      disabledMessage,
      update: newValue => update(updateFormFieldKey(field, FormFieldKeys.PLACEHOLDER, newValue)),
      field
    });
  }
  render() {
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [this.props.RequiredField, /*#__PURE__*/_jsx(Spacer, {}), this.props.HiddenField, /*#__PURE__*/_jsx(Spacer, {}), this.props.LabelField, /*#__PURE__*/_jsx(Spacer, {}), this.props.HelpTextField, /*#__PURE__*/_jsx(Spacer, {}), this.renderPlaceholderField(), /*#__PURE__*/_jsx(Spacer, {}), this.renderDefaultValueField(), /*#__PURE__*/_jsx(Spacer, {}), this.renderValidationField(), /*#__PURE__*/_jsx(Spacer, {}), this.props.ProfillingField, /*#__PURE__*/_jsx(Spacer, {}), this.maybeRenderUseCountryCodeSelectToggle()]
    });
  }
}
const actionCreators = {};
export default connect(null, actionCreators)(PhoneNumber);